import {createReducer} from "redux-act";
import {IDictionary} from "modules/types";
import {LanguageType, RequestState} from "modules/enums";
import {
	fetchHelpPagesJson,
	fetchHelpPagesJsonFailed,
	fetchHelpPagesJsonSuccess,
	fetchChecksumsJSONSuccess,
	fetchFAQJson,
	fetchFAQJsonSuccess,
	fetchFAQJsonFailed,
} from "modules/actions";
import {INameByLang} from "apps/CONTENT_BRACKET/modules/types";

export interface IHelpPagesItem {
	id: number;
	type: string;
	title: string;
	text: string;
	lang: LanguageType;
	game: string;
}

export interface IHelpPages {
	guidelines: Array<IHelpPagesItem>;
	terms: Array<IHelpPagesItem>;
	privacy: Array<IHelpPagesItem>;
	how_to_play: Array<IHelpPagesItem>;
	prizes: Array<IHelpPagesItem>;
}

export interface IFaq {
	id: string;
	title: INameByLang;
	text: INameByLang;
	game: string;
}

export interface IJSONs {
	checksums: IDictionary<string>;
	helpPages: IHelpPages | null;
	faq: IFaq[] | null;
	requestState: RequestState;
	faqRequestState: RequestState;
}

const initial: IJSONs = {
	checksums: {},
	helpPages: null,
	faq: null,
	requestState: RequestState.IDLE,
	faqRequestState: RequestState.IDLE,
};

const onFetchHelpPagesJson = (state: IJSONs) => ({
	...state,
	requestState: RequestState.Requested,
});

const onFetchHelpPagesJsonSuccess = (state: IJSONs, helpPages: IHelpPages) => ({
	...state,
	requestState: RequestState.Received,
	helpPages,
});

const onFetchHelpPagesJsonFailed = (state: IJSONs) => ({
	...state,
	requestState: RequestState.Received,
});

const onFetchFAQJson = (state: IJSONs) => ({
	...state,
	faqRequestState: RequestState.Requested,
});

const onFetchFAQJsonSuccess = (state: IJSONs, FAQ: IFaq[]) => ({
	...state,
	faq: FAQ,
	faqRequestState: RequestState.Received,
});

const onFetchFAQJsonFailed = (state: IJSONs) => ({
	...state,
	faqRequestState: RequestState.Received,
});

export const jsons = createReducer({}, initial)
	.on(fetchChecksumsJSONSuccess, (state, payload) => ({
		...state,
		checksums: payload,
	}))
	.on(fetchHelpPagesJson, onFetchHelpPagesJson)
	.on(fetchHelpPagesJsonSuccess, onFetchHelpPagesJsonSuccess)
	.on(fetchHelpPagesJsonFailed, onFetchHelpPagesJsonFailed)
	.on(fetchFAQJson, onFetchFAQJson)
	.on(fetchFAQJsonSuccess, onFetchFAQJsonSuccess)
	.on(fetchFAQJsonFailed, onFetchFAQJsonFailed);
